import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { User, UserList } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  
  gnBaseURL: any;
  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }

  getAllUser(): Observable<User[]> {
    return this.http.get<User[]>(this.gnBaseURL + 'Users');
  }

  

  addUser(addUserRequest: User): Observable<User> {
    return this.http.post<{ Succeeded: boolean; Data: User; Errors: any }>(this.gnBaseURL + 'Users', addUserRequest).pipe(
      map(response => {
        if (response.Succeeded) {
          return response.Data;
        } else {
          throw new Error('Failed to add user');
        }
      }),
      catchError(error => {
        console.error('Error occurred:', error);
        return throwError(error);
      })
    );
  }

  getUser(id: string): Observable<User> {
    return this.http.get<User>(this.gnBaseURL + 'Users/' + id);
  }

  updateUser(id: string, updateUserRequest: User): Observable<User> {
    return this.http.post<User>(
      this.gnBaseURL + 'Users/' + id,
      updateUserRequest
    );
  }

  deleteUser(id: string): Observable<User> {
    return this.http.delete<User>(
      this.gnBaseURL + 'User/' + id + '/actions/delete'
    );
  }

  GetUserListByCompanyId(id: string) {
    return this.http.get<UserList[]>(
      this.gnBaseURL + 'Users/GetUserListByCompanyId/' + id
    );
  }

  blockUser(id: string): Observable<any> {
    return this.http.get<User>(this.gnBaseURL + 'Users/blockuser/' + id);
  }

  reactivateUser(id: string): Observable<any> {
    return this.http.get<User>(this.gnBaseURL + 'Users/reactivateuser/' + id);
  }

  unblockUser(id: string): Observable<any> {
    return this.http.get<User>(this.gnBaseURL + 'Users/unblockuser/' + id);
  }
  //get user name from emailId
  GetUserListByEmailId(id: string) {
    return this.http.get<UserList[]>(
      this.gnBaseURL + 'Auth/GetUsernamesByEmailId/' + id
    );
  }
}
